import React, { Component } from 'react';
import {
    Alert
} from 'react-bootstrap';
import Auth from '../Auth';

class PremiumAd extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoggedIn: false
        };

        this.auth = new Auth(null);
    }

    componentDidMount() {
        let self = this

        this.auth.checkServerTokenHandler((isLoggedInParam) => {
            if(isLoggedInParam !== null) {
                self.setState({ isLoggedIn: isLoggedInParam })
            }
        })
    }

    render() { 
        return (
            <div>
                {!this.state.isLoggedIn &&
                    <Alert className="text-center mb-4" variant="info">
                        <div className="pb-2">
                            Want to calculate poker odds that includes player folding behavior?
                        </div> 
                        <div>
                            Sign up for remaining 10 free Alpha spots through our&nbsp;
                            <a href="/premium" target="_blank">
                                premium
                            </a>
                            &nbsp;page!
                        </div>
                    </Alert>
                }
            </div>
        )
    }

}

export default PremiumAd;